var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "help_outline_black_24dp_2_",
    "data-name": "help_outline_black_24dp (2)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M0,0H32V32H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M14.6,24.4h2.8V21.6H14.6ZM16,2A14,14,0,1,0,30,16,14.005,14.005,0,0,0,16,2Zm0,25.2A11.2,11.2,0,1,1,27.2,16,11.215,11.215,0,0,1,16,27.2ZM16,7.6a5.6,5.6,0,0,0-5.6,5.6h2.8a2.8,2.8,0,1,1,5.6,0c0,2.8-4.2,2.45-4.2,7h2.8c0-3.15,4.2-3.5,4.2-7A5.6,5.6,0,0,0,16,7.6Z",
    transform: "translate(0 0)",
    fill: "#f1f2f6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpOutline);
export default __webpack_public_path__ + "static/media/help_outline.1412870c8ed316dfc709cbb1aa02267f.svg";
export { ForwardRef as ReactComponent };